/* ========================================================================== *\
    IMPORTS
\* ========================================================================== */

import { bind, forEach, isNil } from 'lodash';
import getOrganisation from '../../03-api/lookup/get-organisation';


/* == IMPORTS =============================================================== */



/* ========================================================================== *\
    PRIVATE VARIABLES
\* ========================================================================== */

const
    moduleName = 'lookup-widget',
    baseCssClass = `js-${moduleName}`,
    cssClasses = {
        valid: 'c-valid-message',
        invalid: 'c-error-message'
    },
    selectors = {
        base: `.${baseCssClass}`,
        input: `.${baseCssClass}-input`,
        output: `.${baseCssClass}-output`
    };

/* == PRIVATE VARIABLES ===================================================== */



/* ========================================================================== *\
    EVENT HANDLING
\* ========================================================================== */

function bindEvents() {
    if (
        this.input === null ||
        this.output === null
    ) {
        return;
    }

    this.input.addEventListener('keyup', bind(onKeyUpMemberId, this));
}

/* == EVENT HANDLING ======================================================== */



/* ========================================================================== *\
    PRIVATE METHODS
\* ========================================================================== */

function onKeyUpMemberId() {   
    const 
        inputRegexPatternValue = this.input.dataset.valRegexPattern,
        inputRegex = new RegExp(inputRegexPatternValue),
        inputValue = this.input.value;

    if(!inputRegex.test(inputValue)) {
        this.output.innerHTML = '';
        return;
    }

    const checkOrganisation = getOrganisation(inputValue);

    this.output.classList.remove(cssClasses.valid, cssClasses.invalid);
    this.output.classList.add('c-loader');

    checkOrganisation
        .then((response) => {
            this.output.innerHTML = response.Name;
            this.output.classList.add(cssClasses.valid);
        })
        .catch((e) => {
            this.output.innerHTML = e.responseText;
            this.output.classList.add(cssClasses.invalid);
        })
        .always(() => {
            this.output.classList.remove('c-loader');
        });
}

/* == PRIVATE METHODS ======================================================= */



/* ========================================================================== *\
    PUBLIC API
\* ========================================================================== */

class Lookup {

    /* ====================================================================== *\
        CONSTRUCTOR
    \* ====================================================================== */

    constructor(baseElement) {
        if (isNil(baseElement)) {
            throw 'Unable to create instance of Lookup, no base element has been provided';
        }

        this.baseElement = baseElement;
        this.input = baseElement.querySelector(selectors.input);
        this.output = baseElement.querySelector(selectors.output);

        bindEvents.call(this);
    }

    /* == CONSTRUCTOR ======================================================= */

}

/* == PUBLIC API ============================================================ */



/* ========================================================================== *\
    INITIALIZATION
\* ========================================================================== */

function init(baseElements = document.querySelectorAll(selectors.base)) {
    if (
        baseElements === null ||
        baseElements.length === 0
    ) {
        return;
    }

    forEach(baseElements, baseElement => {
        new Lookup(baseElement);
    });
}

init();

/* == INITIALIZATION ======================================================== */